require('isomorphic-fetch');
import {sessionExpired as sessionExpiredAction} from '../actions/auth/sessionExpiredAction';

export const CALL_API = Symbol('Call API');

export function callApi(endpoint, method, data, passCredentials) {
    let date = new Date();
    const antiCacheEndpoint = endpoint.split('?').length > 1 ?
        `${endpoint}&t=${date.getTime()}` :
        `${endpoint}?t=${date.getTime()}`;

    function checkStatus(response) {
        if (response.status >= 200 && response.status < 300) {
            return response
        } else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    }

    return fetch(antiCacheEndpoint, {
        method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: method === 'post' ? JSON.stringify(data) : undefined
    }).then(checkStatus).then(response => {
        return response.json().then(json => ({json, response}));
    }).then(({json, response}) => {
        if (!response.ok) {
            return Promise.reject(json);
        }

        return json;
    }).catch(err => {
        console.log(err);//eslint-disable-line no-console
        throw err;
    });
}

export default store => next => action => { //eslint-disable-line no-unused-vars
    const callAPI = action[CALL_API];
    if (typeof callAPI === 'undefined') {
        return next(action);
    }

    const type = action.type;
    let {endpoint} = callAPI;

    const {method,
        types: [
            successType,
            failureType
            ],
        credentials,
        data
        } = callAPI;

    function actionWith(data) {
        const finalAction = Object.assign({}, action, data);
        delete finalAction[CALL_API];

        return finalAction;
    }

    next(actionWith({type, data}));

    return callApi(endpoint, method, data, credentials).then(
            response => {
                let actionsChain = Array.isArray(successType) ? successType : [successType];

                if (response !== undefined) {
                    if (response.sessionExpired !== undefined && response.sessionExpired) {
                        next(sessionExpiredAction());
                        return;
                    }

                    for (let i = 0; i < actionsChain.length; i++) {
                        let actionType = actionsChain[i];

                        if (typeof(actionType) === 'function') {
                            response = actionType(response);
                        } else {
                            next(actionWith({
                                data: response,
                                type: actionType
                            }));
                        }
                    }
                }
            },
            error => next(actionWith({
            type: failureType,
            data: Object.assign({}, data, {
                error: error.message
            })
        }))
    );
};



// WEBPACK FOOTER //
// ./js/middleware/api.js